import React from "react";
import SearchSelect from "Components/Fragment/SearchSelect";
import { decode } from "lib/format";
import withLanguageContext from "lib/hocs/withLanguageContext";

const SelectionDropDown = ({
  languageContext,
  selections,
  onChange,
  selection,
}) => {
  const active = {
    value: `${selection.type}-${selection.id}`,
    label: decode(selection.title),
  };

  const teamOptions = selections
    .filter((item) => item.type === "team")
    .map((item) => {
      return {
        value: `${item.type}-${item.id}`,
        label: decode(item.title),
        group: languageContext("teams"),
      };
    });

  const unitOptions = [
    ...selections
      .filter((item) => item.type === "unit")
      .map((item) => {
        return {
          value: `${item.type}-${item.id}`,
          label: item.title,
          group: languageContext("units"),
        };
      }),
  ];

  const options = [...unitOptions, ...teamOptions];

  return (
    <SearchSelect
      id="managerSelect"
      className="managerSelect"
      placeholder={`${languageContext("selectUnit")}/${languageContext(
        "team",
      )}`}
      value={active}
      options={options}
      groupBy={(option) => option.group}
      getOptionLabel={(option) => option.label}
      onChange={(event, option) => (option ? onChange(option) : null)}
      width="clamp(250px, 40vw, 600px)"
    />
  );
};

export default withLanguageContext(SelectionDropDown, "TalentManagement");
